import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledCard } from '../../../../../../../components/StyledCard';
import { useFragment } from '../../../hooks/useFragment';
import { SubtitleDownloadBtns } from './SubtitleDownloadBtns';
import { useFragmentSubtitleDownloadUrls } from './useFragmentSubtitleDownloadUrls';

export function FragmentSubtitlesFiles() {
  const { fragment } = useFragment();
  const [speakerIdCheck, setSpeakerIdCheck] = useState<boolean>(false);
  const downloadUrls = useFragmentSubtitleDownloadUrls(fragment.id, speakerIdCheck);

  return (
    <StyledCard
      size="sm"
      sx={{ maxWidth: 'md' }}
      title={<FormattedMessage id="fragments.subtitlesStatus.title" defaultMessage="Subtítulos" />}
    >
      <Box>
        <FormControlLabel
          control={
            <Checkbox
              edge="start"
              checked={speakerIdCheck}
              onChange={(event) => {
                setSpeakerIdCheck(event.target.checked);
              }}
            />
          }
          label={
            <FormattedMessage
              id="fragments.subtitlesStatus.add"
              defaultMessage="Agregar ID de speaker"
            />
          }
        />
      </Box>
      <SubtitleDownloadBtns downloadUrls={downloadUrls} />
    </StyledCard>
  );
}
